import { createStore, combineReducers, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { userLoginReducer, USER_INITIAL_STATE } from '../reducers/userReducers';
import switchReducer, { SWITCH_SLICE_INITIAL_STATE } from '../reducers/switch';
import modalToggleReducer, {
  MODAL_TOGGLE_INITIAL_STATE,
} from '../reducers/modalToggle';
import { ThunkDispatch } from 'redux-thunk';

const reducers = combineReducers({
  userLogin: userLoginReducer,
  switchVal: switchReducer,
  modalToggle: modalToggleReducer,
});

const initialState = {
  userLogin: USER_INITIAL_STATE,
  switchVal: SWITCH_SLICE_INITIAL_STATE,
  modalToggle: MODAL_TOGGLE_INITIAL_STATE,
};

const middleware = [thunk];

const store = createStore(
  reducers,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware)),
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, unknown, any>;

export default store;
